import React from 'react';
import { CSSObject } from '@chakra-ui/react';
import { TBetReturn } from '../HeaderRow.types';
import IconSvg from '@/components/common/IconSvg';
import { HeaderRowSchema } from './HeaderRow.styles';

export const RunnerDetails: CSSObject = {
  color: 'alpha.600',
};

export const RunnerDescription: CSSObject = {
  color: 'var(--chakra-black-alpha-600, rgba(0, 0, 0, 0.48))',
  fontWeight: '700',
};

export const BetOdds: CSSObject = {
  color: 'alpha.600',
};

export const TextBarrierNumber: CSSObject = {
  color: 'alpha.600',
};

export const BetReturn = (status: TBetReturn): CSSObject => ({
  color: () => {
    switch (status) {
      case 'won':
        return 'white';
      case 'lost':
        return 'white';
      case 'voided':
        return 'white';
      case 'cancelled':
        return 'white';
      case 'pending':
        return 'gamma.800';
      default:
    }
  },
  bg: () => {
    switch (status) {
      case 'won':
        return 'delta.700';
      case 'lost':
        return 'gamma.900';
      case 'voided':
        return 'gamma.900';
      case 'cancelled':
        return 'gray.400';
      case 'pending':
        return 'linear-gradient(180deg, #53D3FA 0%, #3EB0D3 100%)';
      default:
    }
  },
});

export const HeaderSvg: CSSObject = {
  color: 'alpha.600',
  boxSize: '5',
};

export const BetMultiIcon: CSSObject = {
  boxSize: '5',
  color: 'alpha.600',
};

export const MultiIcon = () => (
  <IconSvg
    name="MultiIconVolcanobet"
    className="svgIcon"
    boxSize="6"
    mb="1.5"
  />
);

export const headerRowStyles: HeaderRowSchema = {
  mysteryBetIcon: {
    fill: 'gamma.500',
  },
  headerRowSvg: {
    fill: 'zeta.400',
  },
};
